export default __webpack_public_path__ + "static/media/am.227ceb68.svg";